export { default } from './FeaturedDestinationContainerMobile';
